import React from 'react'
import { Grid, Box, TextField, IconButton } from '@mui/material';
import GlobalCard from '../../../UI/card/GlobalCard';
import "../../../scss/common.scss";
import "./personalization.scss";
// import Camera from '../../../assets/setting/personalization/camera.png';
import Delete from '../../../assets/setting/personalization/Delete.png';
// import Vector from "../../../assets/setting/personalization/Vector.png";
import { createTheme } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import PhotoCamera from '@mui/icons-material/PhotoCamera';

const Personalization = () => {
  const theme = createTheme({
    palette: {
      primary: {
        main: purple[500],
      },
      secondary: {
        main: '#f44336',
      },
    },
  });
  return (
    <>
      <Grid container className="main-personalization">
        <Grid item md={9}>
          <GlobalCard>
            <button className=' button-text-dark cancel btn btn-light-grey'>Button</button>
            <button className='cancel btn button-background-brown'>Button</button>
            <button className='cancel save btn btn-secondary'>Button</button>
          </GlobalCard>
        </Grid>

        <Grid item md={3}>
          <GlobalCard>
            <h3 className='fw-600 '>Company Logo</h3>
            <Box sx={{ display: "flex" }}>
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "150px", height: "150px", backgroundColor: "#D9DBE9", borderRadius: "8px" }}>
                <IconButton color="primary" aria-label="upload picture" component="label">
                  <input hidden accept="image/*" type="file" />
                  <PhotoCamera sx={{color:"#A0A3BD",width:"50px",height:"50px"}}/>
                </IconButton>
              </Box>
              <Box sx={{ paddingLeft: "20px" }}>
                <img src={Delete} alt="delete" />
              </Box>
            </Box>
            <Box sx={{ my: 3 }}>
              <h3 className='fw-600 fs-24' >Theme Colors</h3>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", border: "1px solid black" }}>
            </Box>

          </GlobalCard>
        </Grid>
      </Grid>
    </>
  )
}

export default Personalization
